import { SaasApiClient } from '@fourthwall/services/dist/SaasApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useCurrentSubscriptionQuery = createQueryHook(SaasApiClient.getCurrentSubscription, {
  queryKey: ['currentSubscription'],
})
